var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right-side-item-content"},[_c('RightSideDescription',{attrs:{"auctionData":_vm.auctionData}}),_vm._v(" "),_c('RightSideImages',{attrs:{"auctionData":_vm.auctionData}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-95896cfc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/right-side-item-content/right-side-item-content.vue
// module id = null
// module chunks = 